import React from 'react';
import AiHistory from './AiHistory';
import DictHistory from './DictHistory';
import styles from '@/assets/styles/History.module.less';

const HistoryContainer: React.FC = () => {
  return (
    <div className={styles.historyContainer}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>🔥 热门搜索</h1>
        <p className={styles.pageSubtitle}>探索最受欢迎的查询词汇</p>
      </div>
      <div className={styles.gridLayout}>
        <DictHistory />
        <AiHistory />
      </div>
    </div>
  );
};

export default HistoryContainer;
